import { render, staticRenderFns } from "./Ic.vue?vue&type=template&id=18d11a52&scoped=true&"
import script from "./Ic.vue?vue&type=script&lang=js&"
export * from "./Ic.vue?vue&type=script&lang=js&"
import style0 from "./Ic.vue?vue&type=style&index=0&id=18d11a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d11a52",
  null
  
)

export default component.exports